// extracted by css-extract-rspack-plugin
export default {"formWidth":"_d454e4de"};